import {Component, OnInit, EventEmitter, Output, Input, ModuleWithComponentFactories} from '@angular/core';
import {DataService} from '../service/data.service';
import {ParamDiversService} from '../service/paramDivers.service';
import * as moment from 'moment';
import {TableListeService} from '../service/tableListe.service';
import {Subscription} from 'rxjs';

export interface Categorie {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-right-nav',
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.scss']
})

export class RightNavComponent implements OnInit {
  @Output() searchChange: EventEmitter<any[]> = new EventEmitter();

  public categorie;
  public themes;
  public catSelected: any = {};
  public sousCatSelected: any = {};
  public textSearch = '';
  public sousCats: any = {};
  public date = {dateDu: '', dateAu: ''};
  public isActive = false;
  public categories: Categorie[] = [
    {value: 'theme', viewValue: 'Thèmes'},
    {value: 'mots', viewValue: 'Mots'},
    {value: 'numeros', viewValue: 'Numéros'},
    {value: 'date', viewValue: 'Date'},
    {value: 'categorie', viewValue: 'Catégorie'}
  ];
  public list;
  public showDate = false;
  public theme: any;
  private searchData: any = null;
  private searchSubscription: Subscription;

  public themeSelect: any;
  public categorieSelect: any;

  constructor(
    private dataService: DataService,
    private paramDiversService: ParamDiversService,
    private tableListeService: TableListeService
  ) {
  }

  selectTheme(e) {
    let contain = false;
    this.theme = e.source.selected.value;
    if (this.searchData === null) {
      this.dataService.initSearchData();
    }
    if (this.searchData.theme === undefined) {
      this.searchData.theme = [];
    }
    this.searchData.theme.map((el) => {
      if (el.id === this.theme) {
        contain = true;
      }
    });
    if (!contain) {
      this.searchData.theme.push({id: this.theme, name: e.source.selected.viewValue});
      this.dataService.setSearchData(this.searchData);
    }
  }

  selectCategorie(e) {
    let contain = false;
    this.categorie = e.source.selected.value;
    if (this.searchData === null) {
      this.dataService.initSearchData();
    }

    if (this.searchData.categorie === undefined) {
      this.searchData.categorie = [];
    }
    this.searchData.categorie.map((el) => {
      if (el.id === this.categorie) {
        contain = true;
      }
    });
    if (!contain) {
      this.searchData.categorie.push({id: this.categorie, name: e.source.selected.viewValue});
      this.dataService.setSearchData(this.searchData);
    }

  }

  onSearchChange() {
    this.searchData = this.searchData === null ? {} : this.searchData;
    this.searchData.search = this.textSearch;
    const dataToSearch = {
      categorie: this.searchData.categorie === undefined ? [] : this.searchData.categorie,
      theme: this.searchData.theme === undefined ? [] : this.searchData.theme,
      search: this.textSearch,
      dateDu: this.date.dateDu !== '' ? moment(this.date.dateDu).format('DD-MM-YYYY') : '',
      dateAu: this.date.dateAu !== '' ? moment(this.date.dateAu).format('DD-MM-YYYY') : ''
    };
    this.dataService.setSearchData(dataToSearch);
  }

  sendSearchData() {
    this.searchData.dateDu = this.date.dateDu !== '' ? moment(this.date.dateDu).format('DD-MM-YYYY') : '';
    this.searchData.dateAu = this.date.dateAu !== '' ? moment(this.date.dateAu).format('DD-MM-YYYY') : '';
    this.dataService.setSearchData(this.searchData);
  }

  selectCategories(event) {
    this.catSelected = event.source.selected;
    this.isActive = false;
    this.textSearch = '';
    if (this.catSelected.value === 'categorie' || this.catSelected.value === 'theme') {
      this.sousCats = this[this.catSelected.value];
    }
    const dataToSearch = {
      type: this.catSelected.value,
      sousType: this.sousCatSelected.value,
      search: this.textSearch,
      dateDu: this.date.dateDu !== '' ? moment(this.date.dateDu).format('DD-MM-YYYY') : '',
      dateAu: this.date.dateAu !== '' ? moment(this.date.dateAu).format('DD-MM-YYYY') : ''
    };
    this.dataService.setSearchData(dataToSearch);
  }

  selectSousCat(event) {
    this.sousCatSelected = event.source.selected;
    this.textSearch = '';
    this.isActive = true;
    this.showDate = true;
    const dataToSearch = {
      type: this.catSelected.value,
      sousType: this.sousCatSelected.value,
      search: this.textSearch,
      dateDu: this.date.dateDu !== '' ? moment(this.date.dateDu).format('DD-MM-YYYY') : '',
      dateAu: this.date.dateAu !== '' ? moment(this.date.dateAu).format('DD-MM-YYYY') : ''
    };
    this.dataService.setSearchData(dataToSearch);
    this.initData();
  }

  initData() {
    this.textSearch = '';
  }

  ngOnInit() {
    this.paramDiversService.getParamByTable('categorie').subscribe((res: any) => {
      this.categories = res;
    });
    this.paramDiversService.getParamByTable('theme').subscribe((res: any) => {
      this.themes = res;
    });
    this.searchSubscription = this.dataService.getSearchData()
      .subscribe((res: any) => {
        this.searchData = res;
      });
  }

  onClick(event: any, name: string) {
    event.stopPropagation();
    switch (name) {
      case 'theme':
        this.themeSelect = undefined;
        break;
      case 'dateDu':
        this.date.dateDu = undefined;
        break;
      case 'dateAu':
        this.date.dateAu = undefined;
        break;
      case 'date':
        console.log('Handling Date');
        break;
      case 'categorie':
        this.categorieSelect = undefined;
        break;
      default:
        console.log('Unknown category');
    }
  }
}
